import React from "react";
import Slider from "react-slick";
import { Box } from "@mui/material";
import Header from "src/Component/content-component/Header";
import Card from "src/Component/card-components/Card";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const imageBaseUrl = process.env.REACT_APP_IMAGE_URL
const img = imageBaseUrl + 'International-Relation/University/guelph.png'
const img2 = imageBaseUrl + 'International-Relation/University/VCU_Seal_sans_logotype.svg.png'
const img3 = imageBaseUrl + 'International-Relation/University/worcester.png'
const img4 = imageBaseUrl + 'International-Relation/University/suc-logo.png'
const img5 = imageBaseUrl + 'International-Relation/University/1Seal.png'
const img6 = imageBaseUrl + 'International-Relation/University/images%20(4).png'
const img7 = imageBaseUrl + 'International-Relation/University/asiaInstitu.png'
const img8 = imageBaseUrl + 'International-Relation/University/yuan.png'
const img9 = imageBaseUrl + 'International-Relation/University/cgu_logo_01.png'
const img10 = imageBaseUrl + 'International-Relation/University/tisan.png'
const img11 = imageBaseUrl + 'International-Relation/University/National_Chung_Cheng_University_logo.svg.png'
const img12 = imageBaseUrl + 'International-Relation/University/asia.png'
const img13 = imageBaseUrl + 'International-Relation/University/cinyi.png'
const img14 = imageBaseUrl + 'International-Relation/University/lincoln.png'
const img15 = imageBaseUrl + 'International-Relation/University/institution-inti.png'
const img16 = imageBaseUrl + 'International-Relation/University/UTM-LOGO.png'
const img17 = imageBaseUrl + 'International-Relation/University/LogoUMPSA.png'
const img18 = imageBaseUrl + 'International-Relation/University/SEGi-University-logo-2023_4C-1022x334-1.png'
const img19 = imageBaseUrl + 'International-Relation/University/mahsa_university_logo.png'
const img20 = imageBaseUrl + 'International-Relation/University/UTHM_Logo.png'
const img21 = imageBaseUrl + 'International-Relation/IndiaPage/UNM.png'
const img22 = imageBaseUrl + 'International-Relation/IndiaPage/UNITEN.png'
const img23 = imageBaseUrl + 'International-Relation/IndiaPage/UI.png'

const Universities = [
  {
    title: "University of Guelph",
    path: "https://www.uoguelph.ca/",
    Image: img,
  },
  {
    title: "Virginia Commonwealth University",
    path: "https://www.vcu.edu/",
    Image: img2,
  },
  {
    title: "Worcester Polytechnic Institute",
    path: "https://www.wpi.edu/",
    Image: img3,
  },
  {
    title: "Skyline University College",
    path: "https://www.skylineuniversity.ac.ae/",
    Image: img4,
  },
  {
    title: "Mariano Marcos State university",
    path: "https://www.mmsu.edu.ph/",
    Image: img5,
  },
  {
    title: "Rajamangala University of Technology Thanyaburi",
    path: "https://www.eng.rmutt.ac.th/",
    Image: img6,
  },
  {
    title: "Asian Institute of Technology",
    path: "https://ait.ac.th/",
    Image: img7,
  },
  {
    title: "Yuan Ze University",
    path: "https://yzu-apply.yzu.edu.tw/",
    Image: img8,
  },
  {
    title: "Chang Gung University",
    path: "https://www.cgu.edu.tw/en",
    Image: img9,
  },
  {
    title: "Tsinghua University ",
    path: "https://www.tsinghua.edu.cn/en/",
    Image: img10,
  },
  {
    title: "National Chengchi University",
    path: "https://www.ccu.edu.tw/?Lang=en",
    Image: img11,
  },
  {
    title: " Asia University Taiwan",
    path: "https://web.asia.edu.tw/",
    Image: img12,
  },
  {
    title: "National Chin-Yi University of Technology",
    path: "https://en.ncut.edu.tw/",
    Image: img13,
  },
  {
    title: "Lincoln University",
    path: "https://www.lincoln.edu.my/",
    Image: img14,
  },
  {
    title: "International University",
    path: "https://newinti.edu.my/",
    Image: img15,
  },
  {
    title: "Universiti Teknologi Malaysia ",
    path: "https://www.utm.my/",
    Image: img16,
  },
  {
    title: "Universiti Malaysia Pahang Al-Sultan Abdullah",
    path: "https://umpsa.edu.my/en",
    Image: img17,
  },
  {
    title: "SEGi University",
    path: "https://www.segi.edu.my/",
    Image: img18,
  },
  {
    title: "Mahsa University",
    path: "https://mahsa.edu.my/",
    Image: img19,
  },
  {
    title: "University of Teknologi Malaysia",
    path: "https://www.utm.my/",
    Image: img20,
  },
  {
    title: "University of New Mexico",
    path: "https://www.unm.edu/",
    Image: img21,
  },
  {
    title: "Universiti Tenaga Nasional",
    path: "https://www.uniten.edu.my/",
    Image: img22,
  },
  {
    title: " University of Indonesia",
    path: "https://www.ui.ac.id/en/",
    Image: img23,
  },
];

const settings = {

  infinite: true,
  arrows: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  speed: 2000,
  autoplaySpeed: 2000,
  cssEase: "linear",
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 3 } },
    { breakpoint: 800, settings: { slidesToShow: 2 } },
    {breakpoint: 500,  settings: {slidesToShow: 1, slidesToScroll: 1, speed: 4000, infinite: true, }, }
  ],
};

const PartnerUniversities = () => {
  return (
    <Box sx={{ textAlign: "center", mt: 4, mb: 6, px: { xs: 2, sm: 5, md: 20 } }}>
      <Header
        content={"Our Partner Universities "}
        textAlign={"center"}
        sx={{ mb: 4 }}
      />
      <Slider {...settings}>

        {Universities.map((item, index) => (
          <Box key={index} className="p-2"  sx={{ my: 4, }}>
            <a href={item?.path} target="_blank" rel="noopener noreferrer">
              <Card
                data={item}
                borderRadius="10%"
                hoverHeight="35%"
                initialheight="23%"
                width="220px"
                height="150px"
                listStyle="none"
                fontSize="20px"
              > 
              <img
              src={item.Image}
              alt={item.title}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                borderRadius: "5px",
                marginBottom: "10px",
              }}
            />
            
            </Card>
            </a>
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default PartnerUniversities;
